module.exports = __webpack_public_path__ + "media/images/lms/d2l-839ed9a7c5d50ce368f88daeff6572dc.png";